import { Card, CardContent, Typography } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Grid } from '@material-ui/core';

export function DebugTab() {
    const { entity } = useEntity();
    // JSX for rendering the component
    return (
        <Grid container spacing={3} alignItems="stretch">
            <Grid item md={12}>
                <Card>
                    <CardContent>
                        <Typography variant="h5">Debug Catalog</Typography>
                        <pre>{JSON.stringify(entity, null, 2)}</pre>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>        
    );
}